module.exports = __webpack_public_path__ + "static/favicons/favicon-196x196-e749c9af3e4eb6c37222699f2485a353.png";